module.exports = __webpack_public_path__ + "img/lg_ring_y_c_0_0@3x.d3206301.png";